import { EMPLOYMENT_TYPE } from 'Common/constants/employmentType';

export const employmentTypeHasAbn = (type) => {
  const types = [EMPLOYMENT_TYPE.PAYE, EMPLOYMENT_TYPE.SELF_EMPLOYED];
  return types.includes(type);
};
